(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * Responsible for implementing the VAST 3.0 Spec subset supported.
     * Relies on the parsing done by vast.js
     * Delegates display, timing and tracking on additional plugins.
     *
     * Responsible for distributing messages to trigger proper ad display, namely:
     *
     * * impressions
     * * errors
     * * wrappers
     * * adwords (non-linears),
     * * pre-mid-post rolls (linears),
     * * tracking events
     * * video clicks
     *
     * Technical limitations:
     *
     * * videos must be in video element compatible formats displayable by the browser (mostly MP4/H264)
     * * wrapper URIs must support CORS!
     *
     * @namespace sv_vast
     */

    /**
     * This message displays a skip button on rolls. Configured via VAST document configuration.
     *
     * @function show_ad_skip
     * @param {String} messageKind='show_ad_skip'
     */

    /**
     * This message displays adwords window.
     *
     * @function show_ads
     * @param {String} messageKind='show_ads'
    */

    /**
     * Occurs when an error happens during parsing of the VAST XML document.
     *
     * @function ad_error
     * @param {String} messageKind='ad_error'
     * @param {Number} errorCode
     * @param {Object} vastObj
     * @param {String} errorMessage
     */



    // internal constants
    var _         = SAPO.Project.Video._,
        Css       = SAPO.Dom.Css,
        Event     = SAPO.Dom.Event,
        Selector  = SAPO.Dom.Selector;



    var genId = function(prefix) {
        return prefix + ( ~~(Math.random() * Math.pow(32, 6)) ).toString(32);
    };



    var plugin = function(vc, ui, pub, pubD) {
        this._vc = vc;
        this._ui = ui;
        this._pub = pub;
        this._pubD = pubD;

        // console.log('SV VAST 2 CREATED');


        // auxiliary markup
        var aEl = this._ui._els.aEl;
        this._counterEl = document.createElement('div');
        this._counterEl.className = 'ad-counter';
        aEl.appendChild(this._counterEl);

        // WTF WP8+ Stock Browser. It needs an unpositioned wrapper for elements above the video...
        this._skipWrap = document.createElement('div');
        this._skipWrap.className = 'skip-wrap';
        aEl.appendChild(this._skipWrap);

        this._skipEl = document.createElement('button');
        this._skipEl.className = 'ad-skip hidden';
        this._skipEl.innerHTML = _('skipTitle');
        this._skipWrap.appendChild(this._skipEl);


        // WTF WP8+ Stock Browser. It needs an unpositioned wrapper for elements above the video...
        this._adwordsWrap = document.createElement('div');
        this._adwordsWrap.className = 'adwords-wrap';
        aEl.appendChild(this._adwordsWrap);

        this._adwordsEl = document.createElement('div');
        this._adwordsEl.className = 'ad-words hidden';
        this._adwordsWrap.appendChild(this._adwordsEl);

        this._awBgEl = document.createElement('div');

        this._awCloseEl = document.createElement('div');
        this._awCloseEl.className = 'dialog-close button x';
        this._adwordsEl.appendChild(this._awCloseEl);

        var onAdwInteractionCb = function(ev) {
            //console.log('onAdwInteractionCb %s', ev.type);

            var clickedClose = (Event.element(ev) === this._awCloseEl);

            Css.addClassName(this._adwordsEl, 'hidden');

            if (!clickedClose) {
                var item = this._vast.parts.nonLinears[0];
                //console.log(item);
                this._pub('metro', item.trackingUrl, 'vast_adword_tracking_url');
            }

            this._pub('invalidate_adwords', {});

            if (clickedClose) {
                return Event.stop(ev);
            }
        }.bindObj(this);

        Event.observe(this._adwordsEl, 'click', onAdwInteractionCb);

        this._vc.subscribe('ad_error invalidate_ad_roll load metadata_changed show_ad_skip show_ads time_updated vast', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'sv_vast2',

        on_metadata_changed: function(mt, md) {
            //console.log('VAST on_metadata_changed', md);
            this._md = md;
        },

        on_vast: function(mt, vast, isRepetition) {
            // console.log('VAST on_vast');
            this._vast = vast;
            this._isRepetition = isRepetition;
            // console.log('VAST on_vast', 'VAST:', vast, 'isRepetition:', !!isRepetition);
        },

        on_load: function(mt, o) {
            if (!this._vast) { return; }

            //console.log('VAST on_load');

            var isAd = o.isAd; //this._md.isAd;

            Css.addRemoveClassName(this._ui._els.player, 'ad', isAd);
            //Css.addRemoveClassName(this._counterEl, 'hidden', !isAd);

            Css.addClassName(this._skipEl,    'hidden');
            Css.addClassName(this._adwordsEl, 'hidden');

            this._applyAds();
        },

        on_invalidate_ad_roll: function() {
            Css.removeClassName(this._ui._els.player, 'ad');
        },

        on_time_updated: function(mt, t) {
            if (!this._md || !this._md.isAd || isNaN(t) || isNaN(this._md.duration)) { return; }
            //console.log('t', t, 'dur', this._md.duration, 'counter', this._md.duration - t);
            this._counterEl.innerHTML = [_('pubTitle'), Math.max(0, Math.round(this._md.duration - t))].join(' ');
        },

        on_show_ad_skip: function() {
            Css.removeClassName(this._skipEl, 'hidden');
        },

        on_show_ads: function() {
            Css.removeClassName(this._adwordsEl, 'hidden');
        },

        on_ad_error: function(mt, errorCode, vastO/*, msg*/) {
            //console.log('AD ERROR', errorCode/*, vastO*/, msg);

            var uris = vastO.error;
            if (!uris) { return; }

            if (typeof uris === 'string') {
                uris = [uris];
            }

            var i, f, u, u2;
            for (i = 0, f = uris.length; i < f; ++i) {
                u = uris[i];
                u2 = u.replace(/\[ERRORCODE\]/g, typeof errorCode === 'number' ? errorCode : 900); // VASTv3.0.pdf page 54 (900 = undefined error)
                this._pub('metro', u2, 'vast_error');
            }
        },



        _populateAdwords: function(items) {
            /*jshint maxcomplexity:20, scripturl:true */

            var ctnEl = this._adwordsEl;
            var i, f, item, itemEl, titleEl, linkEl, pEl;

            var oldItemEls = Selector.select('.item', ctnEl);
            for (i = 0, f = oldItemEls.length; i < f; ++i) {
                ctnEl.removeChild(oldItemEls[i]);
            }

            //console.log(items);

            item = items[0];

            if (item) {
                if (!('adLinkUrl' in item)) {
                    item.adLinkUrl = '#';
                }

                itemEl = document.createElement('a');
                itemEl.className = 'item adw';
                if (item.adLinkUrl) {
                    itemEl.href = item.adLinkUrl;
                    itemEl.target = '_blank';
                    itemEl.setAttribute('rel', 'external');
                }
                else {
                    itemEl.href = 'javascript:void(0)';
                }

                titleEl = document.createElement('div');
                titleEl.className = 'aw-title';
                titleEl.appendChild( document.createTextNode(item.title) );
                itemEl.appendChild(titleEl);

                if (item.displayUrl) {
                    linkEl = document.createElement('div');
                    linkEl.className = 'link';
                    linkEl.appendChild( document.createTextNode(item.displayUrl) );
                    itemEl.appendChild(linkEl);
                }

                for (i = 0, f = item.lines.length; i < f; ++i) {
                    pEl = document.createElement('p');
                    pEl.appendChild( document.createTextNode( item.lines[i] ) );
                    itemEl.appendChild(pEl);
                }

                ctnEl.appendChild(itemEl);
            }
        },

        _applyAds: function() {
            /*jshint maxcomplexity:200 */
            // console.log('APPLYING ADS');

            var v = this._vast;

            var md = this._md;
            var dur    = md.duration;
            var midDur = dur/2;
            var delta = 5;
            var roll;



            // ADWORDS
            // console.log(this._md);
            if (!this._md.isAd) {
                this._populateAdwords(v.parts.nonLinears);
            }

            var rollExtras = {
                pre:  {start:0,           end:midDur-0.01},
                mid:  {start:midDur,      end:dur-delta/2-0.01},
                post: {start:dur-delta/2, end:dur}
            };

            var currentReqURL = this._vc.getCurrentRequestURL();


            // TODO REFACTOR THIS INTO AD AND NOT_AD CASES


            // ROLLS
            var rollReqURL, rollExtra, cueId;
            //console.log('ITERATING ROLLS');
            for (var rollName in v.parts.linears) { // TODO PORT THESE
                if (! v.parts.linears.hasOwnProperty(rollName)) { continue; }

                roll = v.parts.linears[rollName];
                rollExtra = rollExtras[rollName];

                cueId = genId('cue_');
                // let sv_roll plugin handle events piping to *metro...
                rollReqURL = roll.src;

                /*console.warn('rollRequestURL', rollReqURL);
                console.warn('currentReqURL ', currentReqURL);*/

                this._pub('roll_info', {
                    roll:           roll,
                    rollName:       rollName,
                    rollRequestURL: rollReqURL
                });

                if (rollName !== 'pre' && !this._md.isAd) {
                    // schedule rolls playback
                    this._pub('add_timeline', {
                        kind: 'pub',
                        start: rollExtra.start,
                        end:   rollExtra.end,
                        args:  ['remove_cue', cueId],
                        once: true
                    },
                    currentReqURL);

                    this._pub('add_timeline', {
                        kind: 'pub',
                        start: rollExtra.start,
                        end:   rollExtra.end,
                        args:  ['call', 'load', rollReqURL, true, true], // uri isAd autoplay
                        once: true,
                        stopProcessing: true
                    },
                    currentReqURL);

                    this._pub('add_cue', {
                        title: _('linearAdTitle'),
                        value: rollExtra.start,
                        id:    cueId,
                        //color: 'rgba(255, 255, 255, 0.5)',
                        width: 2
                    },
                    currentReqURL);
                }

                //console.log('this._md.isAd', this._md.isAd, roll);
                if (this._md.isAd) {
                    if (roll.adParameters.allowCloseButton) {
                        this._pub('add_timeline',
                            {
                                kind:   'pub',
                                start:   roll.adParameters.timeForCloseButton || 10,
                                end:     100000000,
                                args:    ['show_ad_skip'],
                                once: true
                            },
                            rollReqURL
                        );
                    }

                    // quartiles
                    //console.log('sending quartiles...');

                    if ('creativeView' in roll.tracking) {
                        this._pub('add_timeline',
                            {
                                kind: 'pub',
                                start: 0,
                                end:   100000000,
                                args:  ['metro', roll.tracking.creativeView, 'vast_creativeView'],
                                once: true
                            },
                            rollReqURL
                        );
                    }

                    if ('start' in roll.tracking) {
                        this._pub('add_timeline',
                            {
                                kind: 'pub',
                                start: 0,
                                end:   100000000,
                                args:  ['metro', roll.tracking.start, 'vast_start'],
                                once: true
                            },
                            rollReqURL
                        );
                    }

                    if ('firstQuartile' in roll.tracking) {
                        this._pub('add_timeline',
                            {
                                kind: 'pub',
                                start: 0.25,
                                end:   100000000,
                                args:  ['metro', roll.tracking.firstQuartile, 'vast_firstQuartile'],
                                asRatios: true,
                                once: true
                            },
                            rollReqURL
                        );
                    }

                    if ('midpoint' in roll.tracking) {
                        this._pub('add_timeline',
                            {
                                kind: 'pub',
                                start: 0.5,
                                end:   100000000,
                                args:  ['metro', roll.tracking.midpoint, 'vast_midpoint'],
                                asRatios: true,
                                once: true
                            },
                            rollReqURL
                        );
                    }

                    if ('thirdQuartile' in roll.tracking) {
                        this._pub('add_timeline',
                            {
                                kind: 'pub',
                                start: 0.75,
                                end:   100000000,
                                args:  ['metro', roll.tracking.thirdQuartile, 'vast_thirdQuartile'],
                                asRatios: true,
                                once: true
                            },
                            rollReqURL
                        );
                    }
                }
            }

            // request timeline to show adwords at 10 seconds
            if (v.parts.nonLinears.length > 0 && !this._md.isAd) {

                cueId = genId('cue_');

                this._pub('add_cue', {
                    title: _('nonlinearAdTitle'),
                    value: 10,
                    id:    cueId,
                    width: 2,
                    once: true
                }, currentReqURL);

                this._pub('add_timeline', {
                    kind: 'pub',
                    start: 10,
                    end:   100000000,
                    args:  ['remove_cue', cueId],
                    once: true
                }, currentReqURL);

                this._pub('add_timeline', {
                    kind: 'pub',
                    start: 10,
                    end:   100000000,
                    args:  ['show_ads'],
                    once: true
                }, currentReqURL);

                this._pub('add_timeline', {
                    kind: 'pub',
                    start: 10,
                    end:   100000000,
                    args:  ['metro', v.parts.nonLinears.impression, 'vast_nonlinear_impression'],
                    once: true
                }, currentReqURL);
            }
        }
    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
